export default __webpack_public_path__ + "static/13-52a18430b58f7c528591e40a889541f2.jpg";